import { Divider, Paper, Typography } from "@mui/material";
import HocPopup from "../../../hoc/hocPopup";
import React, { useEffect, useState } from "react";
import AppButton from "../AppButton.component";
import { TYPE } from "../../../utils/Utils";
import DialogComponent from "../Dialog.component";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/Auth.context";
import { useAppContext } from "../../../context/App.context";

const DIALOG_INITIAL_STATE = {
  open: false,
  bodyType: TYPE.DEFAULT,
  title: "",
  body: null,
};

const AutoLogoutDialog = ({}) => {
  const [dialog, setDialog] = useState(DIALOG_INITIAL_STATE);
  const navigate = useNavigate();
  const auth = useAuth();
  const app = useAppContext();
  useEffect(() => {
    setDialog({
      open: true,
      bodyType: TYPE.LOGOUT,
      title: "Warning",
      body: (
        <Paper
          sx={{
            background: "white",
            padding: "16px",
            display: { xs: "contents", sm: "flex" },
            justifyContent: "center",
            boxShadow: "none",
          }}
        >
          <Typography
            variant="h6"
            sx={{ paddingLeft: "8px", fontWeight: "bold" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p>
                Session Expired: It looks like your session has ended. Please
                log in again to continue.
              </p>

              <AppButton
                sx={{ width: "40%", alignSelf: "center" }}
                buttonText="Log In"
                size="small"
                variant="contained"
                clickHandler={() => {
                  auth.logout();
                  app.removeAll();
                  navigate("/login");
                }}
              />
            </div>
          </Typography>
        </Paper>
      ),
    });
  }, []);

  return (
    <DialogComponent
      open={dialog.open}
      bodyType={dialog.bodyType}
      body={dialog.body}
      title={dialog.title}
      onClose={() => {
        setDialog({ ...dialog, open: false });
        auth.logout();
        app.removeAll();
        navigate("/login");
      }}
    />
  );
};
export default HocPopup(AutoLogoutDialog);
